export function getWeekRange(date: Date) {
  const currentDate = new Date(date);
  const dayOfWeek = currentDate.getDay(); // 0 (Sunday) to 6 (Saturday)
  const startOfWeek = new Date(currentDate);
  startOfWeek.setDate(
    currentDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1)
  ); // Adjust if Sunday
  startOfWeek.setHours(0, 0, 0, 0);

  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);
  endOfWeek.setHours(23, 59, 59, 999);

  return { startOfWeek, endOfWeek };
}

export function getMonthRange(date: Date) {
  const currentDate = new Date(date);
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  startOfMonth.setHours(0, 0, 0, 0);

  const endOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );
  endOfMonth.setHours(23, 59, 59, 999);

  return { startOfMonth, endOfMonth };
}

export function getYearRange(date: Date) {
  const currentDate = new Date(date);
  const startOfYear = new Date(currentDate.getFullYear(), 0, 1);
  startOfYear.setHours(0, 0, 0, 0);

  const endOfYear = new Date(currentDate.getFullYear(), 11, 31);
  endOfYear.setHours(23, 59, 59, 999);

  return { startOfYear, endOfYear };
}

export function getLastTwelweMonths() {
  const currentDate = new Date();
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 11,
    1
  );
  startOfMonth.setHours(0, 0, 0, 0);

  const endOfMonth = new Date(currentDate);
  endOfMonth.setHours(23, 59, 59, 999);

  return { start: startOfMonth, end: endOfMonth };
}

export const yearsToShow = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: currentYear - 2022 }, (_, i) => currentYear - i);
};
